<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb" title="settings.contractingAuthority.ac.new.title"></sm-page-header>
    <div class="content">
        <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
        <div class="flex justify-end gap-2">
            <p-button [label]="'settings.contractingAuthority.ac.new.add' | translate" (click)="addContractingAuthority()" />
            <p-button [label]="'settings.contractingAuthority.ac.new.reset' | translate" severity="secondary" (click)="reset()"/>
        </div>
  </div>
</div>
